import { render, staticRenderFns } from "./Refund4ReasonPage.vue?vue&type=template&id=5ae275ef"
import script from "./Refund4ReasonPage.vue?vue&type=script&lang=js"
export * from "./Refund4ReasonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports